export default __webpack_public_path__ + "static/ponkes-schools-out-45cb1d316cda48ab3ab24a8c4e274a35.jpg";